import { useEffect, useMemo, useState } from 'react';
import debounce from 'modules/debounce/debounce';

export default function useFilters(
  storageKey,
  callback = () => {},
  defaults = {},
) {
  const [filters, setFilters] = useState(
    JSON.parse(localStorage.getItem(storageKey)) || defaults,
  );

  const debouncedOnFiltersChange = useMemo(
    () => debounce(callback, 800),
    [callback],
  );

  useEffect(() => {
    if (!storageKey) {
      console.warn('There is no storageKey!');

      return;
    }

    localStorage.setItem(storageKey, JSON.stringify(filters));
    debouncedOnFiltersChange(filters);
  }, [filters, debouncedOnFiltersChange, storageKey]);

  return [filters, setFilters];
}
